import { UserGroup } from 'src/types/users';

export function parseMainGroup(groups: string[] = []): string {
  if (groups.includes(UserGroup.SUPER_ADMIN)) {
    return 'Super Admin';
  }

  if (
    groups.includes(UserGroup.RESEARCHER)
  ) {
    return 'Researcher';
  }

  if(groups.includes(UserGroup.ADMIN)) {
    return 'Admin';
  }

  if (groups.includes(UserGroup.PARTICIPANT)) {
    return 'Participant';
  }

  return '';
}
